import qs from 'querystring'
import _ from 'underscore'

import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'

const url = COOKIECONSTANT.REQUEST_HOST
const emptyOrderListData = {
  total: 0,
  list: [],
}
const emptyListData = {
  list: [],
  page: {
    total: 0,
  },
}
const getRefundList = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  Api.get(`${url}${query}`, {
    headers: {
      'X-Host': 'mall.after-sale.list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
        .then((data) => {
          if (data.status == 6003) {
            return resolve(emptyOrderListData)
          }
          if (data.status !== 0) {
            return reject(data.msg)
          }
          resolve(data.data)
        }, (e) => {
          reject(e)
        })
})
const getRefundDetail = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
      // Api.get('http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/after-sale/detail', {
  Api.get(url + query, {
    headers: {
      'X-Host': 'mall.after-sale.detail',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
        .then((data) => {
          if (data.status != 0) {
            return reject(data)
          }
          resolve(data.data)
        }, (e) => {
          reject(e)
        })
})
const applyRefund = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.apply',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
        .then((data) => {
          if (data.status != 0) {
            return reject(data)
          }
          resolve(data.data)
        }, (e) => {
          reject(e)
        })
})
/* 售后申请前置条件 */
const getRefundReason = queryData => new Promise((resolve, reject) => {
  // Api.post('http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/after-sale/reason', {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      // 'X-Host': 'mall.after-sale.reason',
      // 'X-Host': 'mall.after-sale.pre-apply-info',
      'X-Host': 'mall.after-sale.pre-apply-info-v2',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      'Content-Type': 'application/json',
    },
  })
  .then((data) => {
    if (data.status != 0) {
      return reject(data)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})
const getServiceType = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  Api.get(url + query, {
    headers: {
      'X-Host': 'mall.after-sale.query-service-type',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
      .then((data) => {
        if (data.status != 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
})
  // 退换货金额明细
const getRefundAmountDetail = queryData => new Promise((resolve, reject) => {
      // Api.post('http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/after-sale/refund-detail', {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.refund-detail',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
      .then((data) => {
        // return reject({
        //   status: 6813033,
        //   msg: '当前商品暂不支持拆分退换，请按照默认数量申请售后。'
        // })
        if (data.status != 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
})
const getCompoanyList = queryData => new Promise((resolve, reject) => {
  Api.get(url, {
    headers: {
      'X-Host': 'mall.after-sale.express.company-list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
      .then((data) => {
        if (data.status != 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
})
const cancelRefund = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  Api.get(url + query, {
    headers: {
      'X-Host': 'mall.after-sale.cancel',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
        .then((data) => {
          if (data.status != 0) {
            return reject(data)
          }
          resolve(data)
        }, (e) => {
          reject(e)
        })
})
const commitExpress = queryData => new Promise((resolve, reject) => {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.commit-express',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
      .then((data) => {
        if (data.status != 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
})

const checkRefundTime = queryData => new Promise((resolve, reject) => {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.check-after-sales',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
      .then((data) => {
        if (data.status != 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
})

const uploadAfterSaleImage = queryData => new Promise((resolve, reject) => {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.append-image',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      'Content-Type': 'application/json',
    },
  })
      .then((data) => {
        if (data.status != 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
})

const getRefundOptions = queryData => new Promise((resolve, reject) => {
      // Api.post('http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/after-sale/refund-options', {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.refund-rate-options',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
  .then((data) => {
    if (data.status != 0) {
      return reject(data)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

const confirmPickup = queryData => new Promise((resolve, reject) => {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.confirm-express',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
      .then((data) => {
        if (data.status != 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
})
/**
 * 用户修改收货地址
 * @param {Object} queryData
 * @param {Number} queryData.addressId
 * @param {string} queryData.orderId
 *
 *  */
const updateOrderAddress = queryData => new Promise((resolve, reject) => {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.update-address',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
      .then((data) => {
        if (data.status != 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
})
/**
 * 获取退货&换货&修改地址订单列表
 * @param {Object} queryData
 * @param {Number} queryData.businessType //类型 1：退货,2：换货，3:修改地址
 * @param {Number} queryData.pageNumber
 * @param {Number} queryData.pageSize
 *  */
const getSelfServiceOrderList = queryData => new Promise((resolve, reject) => {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.order-list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status == 6003) {
        return resolve(emptyListData)
      }
      if (data.status != 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})
/**
 * 是否需要上传运费凭证（暂用不到）
 * @param {Object} queryData
 * @param {Number} queryData.userExpressFee 运费
 * @param {string} queryData.serviceId
 *  */
const checkNeedFreightVoucher = queryData => new Promise((resolve, reject) => {
  Api.post(url, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.after-sale.is_need_freight_voucher',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})
/**
 * 获取上传运费凭证规则
 * @param {Object} queryData
 * @param {string} queryData.serviceId
 * 返回"data":{
        "ruleStatus":0,  //规则是否启用  0:启用，1:未启用
        "expressFeeLimit":3000  //运费阀值 //规则启动， 运费必须不大于阈值
    }
 */
const getExpressFeeRule = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  Api.get(url + query, {
    headers: {
      'X-Host': 'mall.after-sale.get_express_fee_rule',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})
export default {
  getRefundList,
  getRefundDetail,
  getRefundReason,
  applyRefund,
  getServiceType,
  getRefundAmountDetail,
  getCompoanyList,
  cancelRefund,
  commitExpress,
  checkRefundTime,
  uploadAfterSaleImage,
  getRefundOptions,
  confirmPickup,
  updateOrderAddress,
  getSelfServiceOrderList,
  checkNeedFreightVoucher,
  getExpressFeeRule,
}
